import { Box, Chip, Typography } from "@mui/material";
import { mesfColors } from "@/setup/ag-grid/mesf-theme";
import type { MillVisualizerData } from "../models/MillVisualizer";
import { statusToBorder } from "../utils/statusToBorder";

interface Props {
	data: MillVisualizerData;
}

export const VisualizerHeader = ({ data }: Props) => {
	const statusColor = statusToBorder(data.globalStatus);
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1.5,
				py: 0.5,
				px: 1,
				borderBottom: `1px solid ${mesfColors.grey[200]}`,
			}}
		>
			<Typography
				variant="subtitle2"
				sx={{ fontWeight: 700, color: mesfColors.text.primary }}
			>
				{data.millName}
			</Typography>
			<Box sx={{ width: "1px", height: 16, bgcolor: mesfColors.grey[300] }} />
			<Typography variant="caption" sx={{ color: mesfColors.text.secondary }}>
				Billets in mill:
			</Typography>
			<Chip
				size="small"
				label={data.billetCount}
				sx={{
					height: 20,
					fontSize: "0.72rem",
					fontWeight: 600,
					bgcolor:
						data.billetCount > 0
							? mesfColors.background.highlight
							: mesfColors.grey[100],
				}}
			/>
			<Box sx={{ flex: 1 }} />
			<Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
				<Box
					sx={{
						width: 10,
						height: 10,
						borderRadius: "50%",
						bgcolor: statusColor,
						boxShadow: `0 0 6px ${statusColor}`,
					}}
				/>
				<Typography
					variant="caption"
					sx={{
						fontWeight: 700,
						textTransform: "uppercase",
						color: statusColor,
						letterSpacing: "0.05em",
					}}
				>
					{data.globalStatus}
				</Typography>
			</Box>
		</Box>
	);
};
